import React from "react";
import "./Banner.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const slides = [
  "/assets/images/home/home-banner/banner1.png",
  "/assets/images/home/home-banner/banner2copy.png",
  "/assets/images/home/home-banner/banner3copy.png",
];

function Banner({ appsetups }) {
  console.log(appsetups, "appsetupsappsetups");

  return (
    <section className="banner-section">
      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        // autoplay={{ delay: 3000 }}
        loop={true}
        slidesPerView={1}
        className="banner-slider"
      >
        {slides.map((img, index) => (
          <SwiperSlide key={index}>
            <div className="banner-slide">
              <img
                className="banner-image"
                src={img}
                alt={`Slide ${index + 1}`}
              />

              <div className="banner-buttons desktop_view">
                <div className="container d-flex gap-5 justify-content-center">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.pmroadcustomer"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="store-btn"
                  >
                    <img
                      src="/assets/images/about_us/User.png"
                      alt="Google Play User"
                    />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.pmroaddriver"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="store-btn"
                  >
                    <img
                      src="/assets/images/about_us/Owner.png"
                      alt="Google Play Owner"
                    />
                  </a>

                  <a
                    href="https://www.apple.com/app-store/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="store-btn"
                  >
                    <img
                      src="/assets/images/about_us/app_store_user.jpg"
                      alt="app store user"
                    />
                  </a>
                  <a
                    href="https://www.apple.com/app-store/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="store-btn"
                  >
                    <img
                      src="/assets/images/about_us/app_store_owner.png"
                      alt="app store owner"
                    />
                  </a>
                  <a
                    href={appsetups?.youtube_link || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="store-btn"
                  >
                    <img src="/assets/images/about_us/yt.png" alt="YouTube" />
                  </a>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="banner-buttons mobile_view">
        <a
          href="https://play.google.com/store/apps/details?id=com.pmroadcustomer"
          target="_blank"
          rel="noopener noreferrer"
          className="store-btn"
        >
          <img src="/assets/images/about_us/User.png" alt="Google Play User" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.pmroaddriver"
          target="_blank"
          rel="noopener noreferrer"
          className="store-btn"
        >
          <img
            src="/assets/images/about_us/Owner.png"
            alt="Google Play Owner"
          />
        </a>

        <a
          href="https://www.apple.com/app-store/"
          target="_blank"
          rel="noopener noreferrer"
          className="store-btn"
        >
          <img
            src="/assets/images/about_us/app_store_user.jpg"
            alt="app store user"
          />
        </a>
        <a
          href="https://www.apple.com/app-store/"
          target="_blank"
          rel="noopener noreferrer"
          className="store-btn"
        >
          <img
            src="/assets/images/about_us/app_store_owner.png"
            alt="app store owner"
          />
        </a>
        <a
          href={appsetups?.youtube_link || "#"}
          target="_blank"
          rel="noopener noreferrer"
          className="store-btn"
        >
          <img src="/assets/images/about_us/yt.png" alt="YouTube" />
        </a>
      </div>
    </section>
  );
}

export default Banner;
